module.exports = __webpack_public_path__ + "img/fuzzcv-free.883643a7.webp";